import { call, put, select, takeLatest } from 'redux-saga/effects';

import { EIntegrationTypes, EWizardSteps } from '../../utils/enums';
import httpClient, { BaseUrl } from '../../utils/httpClient';
import {
  AUTH_TWITTER_REQUEST,
  CAMPAIGNS_CONVERT_EMAIL_REQUEST,
  DISCONNECT_INTEGRATION_REQUEST,
  INSTAGRAM_ADD_ACCOUNT_REQUEST,
  INSTAGRAM_CHECK_CODE_REQUEST,
  INSTAGRAM_VERIFY_ACCOUNT_REQUEST,
  INTEGRATIONS_CONNECT_REQUEST,
  INTEGRATIONS_GET_CONNECTED_REQUEST,
  VERIFY_INTEGRATION_REQUEST,
} from '../actions/actionTypes';
import { createCampaignStore, setTargetIntegrationsUpdate, storeCampaignName } from '../actions/campaign';
import {
  connectSucceed,
  convertEmailError,
  disconnectIntegrationError,
  disconnectIntegrationStore,
  getConnectedIntegrationsAllStore,
  getConnectedIntegrationsError,
  getConnectedIntegrationsStore,
  instagramAddAccountFailed,
  instagramAddAccountSucceed,
  instagramCheckCodeFailed,
  instagramCheckCodeSucceed,
  instagramStoreAccountId,
  instagramVerifyAccountFailed,
  instagramVerifyAccountSucceed,
  verifyIntegrationError,
  verifyIntegrationSuccess,
} from '../actions/integrations';
import { socialPagesStore } from '../actions/post';
import { openStep, setStepAsCompleted } from '../actions/steps';
import { storeFiles, storeTextBody } from '../actions/wizard';
import { getConnected } from '../reducers/integrations';

// connect new
function* connectSaga({ payload }) {
  yield put(connectSucceed({ id: payload, enabled: true }));
}

export function* integrationsWatcher() {
  yield takeLatest(INTEGRATIONS_CONNECT_REQUEST, connectSaga);
}

// connected list
function getConnectedApiCall(type) {
  const profileId = localStorage.getItem('unilinkProfileId');
  return httpClient.get(`api/profiles/${profileId}/integration`);
}

function* getConnectedIntegrationsSaga() {
  try {
    const { data } = yield call(getConnectedApiCall);

    let connectedIds = [];

    console.log('getConnectedIntegrationsSaga data', data);

    if (data['isFacebook']) {
      connectedIds.push(EIntegrationTypes.FACEBOOK);
    }

    if (data['isIgFacebook']) {
      connectedIds.push(EIntegrationTypes.IGFACEBOOK);
    }

    // if (data['is_vkontakte']) {
    //   connectedIds.push(EIntegrationTypes.VKONTAKTE);
    // }

    if (data['isTwitter']) {
      connectedIds.push(EIntegrationTypes.TWITTER);
    }

    if (data['isInstagram']) {
      connectedIds.push(EIntegrationTypes.INSTAGRAM);
    }

    // if (data['is_odnoklassniki']) {
    //   connectedIds.push(EIntegrationTypes.ODNOKLASSNIKI);
    // }

    if (data['isLinkedin']) {
      connectedIds.push(EIntegrationTypes.LINKEDIN);
    }
    if (data['isTelegram']) {
      connectedIds.push(EIntegrationTypes.TELEGRAM);
    }

    if (data['isPinterest']) {
      connectedIds.push(EIntegrationTypes.PINTEREST);
    }

    if (data['isThreads']) {
      connectedIds.push(EIntegrationTypes.THREADS);
    }

    if (data['isDiscord']) {
      connectedIds.push(EIntegrationTypes.DISCORD);
    }

    yield put(getConnectedIntegrationsStore(connectedIds));
    yield put(getConnectedIntegrationsAllStore(data));
  } catch (error) {
    console.log('getConnectedIntegrationsSaga error', error.toString());

    yield put(getConnectedIntegrationsError(error.Message ? error.Message : error.toString()));
  }
}

export function* getConnectedIntegrationsWatcher() {
  yield takeLatest(INTEGRATIONS_GET_CONNECTED_REQUEST, getConnectedIntegrationsSaga);
}

// disconnect
function disconnectApiCall(id, type) {
  const profileId = localStorage.getItem('unilinkProfileId');
  return httpClient.delete(`api/profiles/${profileId}/integration/${type}/${id}`);
}

function* disconnectIntegrationSaga({ payload }) {
  try {
    yield call(disconnectApiCall, payload);

    yield put(disconnectIntegrationStore(payload));
  } catch (error) {
    console.log('disconnectIntegrationSaga error', error);

    yield put(disconnectIntegrationError(error.Message ? error.Message : error.toString()));
  }
}

export function* disconnectIntegrationWatcher() {
  yield takeLatest(DISCONNECT_INTEGRATION_REQUEST, disconnectIntegrationSaga);
}

// verify integration
function verifyVkApi(code) {
  return httpClient.post(`api/vkontakte/verify`, { code });
}

function* verifyVkSaga({ payload }) {
  try {
    const { data } = yield call(verifyVkApi, payload);

    if (!data.success) {
      yield put(verifyIntegrationError(data.error ? data.error : 'Something went wrong'));
    } else {
      yield call(getConnectedIntegrationsSaga);
      yield put(verifyIntegrationSuccess(data));
    }
  } catch (error) {
    console.log('verifyVkSaga error', error);

    let message = error.Message ? error.Message : error.toString();

    yield put(verifyIntegrationError(message));
  }
}

export function* verifyVkWatcher() {
  yield takeLatest(VERIFY_INTEGRATION_REQUEST, verifyVkSaga);
}

// open auth window
function authTwitterApi() {
  // https://twitter.com/i/oauth2/authorize?response_type=code&client_id=Q0pkQVVyVDFrb2dlb0tFVnFnV3I6MTpjaQ&redirect_uri=https://unilink.us/twitter/callback&scope=tweet.read%20tweet.write%20users.read%20offline.access&state=state&code_challenge=challenge&code_challenge_method=plain
  return httpClient.get(`api/twitter/auth`);
}

function* authTwitterSaga() {
  try {
    const { data } = yield call(authTwitterApi);
    window.location = data;
  } catch (error) {
    console.log('authTwitterSaga error', error);
  }
}

export function* authTwitterWatcher() {
  yield takeLatest(AUTH_TWITTER_REQUEST, authTwitterSaga);
}

// ig add account
function igAddAccountApi(body) {
  return httpClient.post(`api/instagram/add`, body);
}

function igLinkAccountApi(id) {
  return httpClient.post(`api/instagram/link?id=${id}`);
}

function* igAddAccountSaga({ payload }) {
  try {
    const { data: accountId } = yield call(igAddAccountApi, payload);

    if (accountId) {
      const { data: verifyResult } = yield call(igLinkAccountApi, accountId);

      yield put(instagramStoreAccountId(accountId));
      yield put(instagramAddAccountSucceed(verifyResult));
    }
  } catch ({ response }) {
    console.log('igAddAccountSaga error', response);

    let message = 'Server error.';

    if (response && response.data) {
      message = response.data.Message;
    }

    yield put(instagramAddAccountFailed(message));
  }
}

export function* igAddAccountWatcher() {
  yield takeLatest(INSTAGRAM_ADD_ACCOUNT_REQUEST, igAddAccountSaga);
}

// ig verify account
function igVerifyAccountApi({ accountId, type, checkpointUrl }) {
  return httpClient.post(`api/instagram/verify`, {
    accountId,
    choice: type,
    checkpoint_url: checkpointUrl,
  });
}

function* igVerifyAccountSaga({ payload }) {
  try {
    const { data: sendCodeStatus } = yield call(igVerifyAccountApi, payload);

    yield put(instagramVerifyAccountSucceed(sendCodeStatus));
  } catch ({ response }) {
    console.log('igVerifyAccountSaga error', response.data);

    const message = response.data.Message || 'Server error';

    yield put(instagramVerifyAccountFailed(message));
  }
}

export function* igVerifyAccountWatcher() {
  yield takeLatest(INSTAGRAM_VERIFY_ACCOUNT_REQUEST, igVerifyAccountSaga);
}

// ig check code
function igCheckCodeApi({ accountId, code, checkpointUrl }) {
  return httpClient.post(`api/instagram/code`, {
    accountId,
    code,
    checkpoint_url: checkpointUrl,
  });
}

function* igCheckCodeSaga({ payload }) {
  try {
    const { data: securityCheckOk } = yield call(igCheckCodeApi, payload);

    if (securityCheckOk > 0) {
      yield put(instagramCheckCodeSucceed());
    } else {
      yield put(instagramCheckCodeFailed(securityCheckOk));
    }
  } catch ({ response }) {
    console.log('igCheckCodeSaga error', response.data);

    let message = 'Server error.';

    if (response && response.data) {
      message = response.data.Message;
    }

    yield put(instagramCheckCodeFailed(message));
  }
}

export function* igCheckCodeWatcher() {
  yield takeLatest(INSTAGRAM_CHECK_CODE_REQUEST, igCheckCodeSaga);
}

// convert email
function getConvertEmailApiCall({ umid }) {
  return httpClient.post(`api/convert/email`, {
    umid,
  });
}

function getSingleCampaignApiCall(id, profileId) {
  return httpClient.get(`api/profiles/${profileId}/campaigns/${id}`);
}

function getSocialPagesApiCall(data, profileId) {
  return httpClient.post(`api/profiles/${profileId}/ccampaigns/pages`, data);
}

function* getConvertEmailSaga({ payload }) {
  try {
    const { data: emailCampaignId } = yield call(getConvertEmailApiCall, payload);

    if (emailCampaignId) {
      const { data: campaignData } = yield call(getSingleCampaignApiCall, emailCampaignId);

      yield put(createCampaignStore(emailCampaignId));

      const targetIntegrations = yield select(getConnected);
      yield put(setTargetIntegrationsUpdate(targetIntegrations));

      if (campaignData.content) {
        yield put(storeTextBody(campaignData.content));
      }

      if (campaignData.images && campaignData.images.length) {
        yield put(storeFiles(campaignData.images.map((x) => `${BaseUrl}/upload/${x}`)));
      }

      if (campaignData.title) {
        yield put(storeCampaignName(campaignData.title));
      }

      const { data: socialPagesData } = yield call(getSocialPagesApiCall, targetIntegrations);
      yield put(socialPagesStore(socialPagesData));

      yield put(setStepAsCompleted(EWizardSteps.CAMPAIGN));
      yield put(openStep(EWizardSteps.POST));
    }
  } catch ({ response }) {
    console.log('getConvertEmailSaga error', response);

    let message = 'Server error. Please try again later.';

    if (response && response.data && response.data.Message) {
      message = response.data.Message;
    } else if (response && response.data) {
      message = response.data;
    }

    yield put(convertEmailError(message));
  }
}

export function* getConvertEmailWatcher() {
  yield takeLatest(CAMPAIGNS_CONVERT_EMAIL_REQUEST, getConvertEmailSaga);
}
